export default __webpack_public_path__ + "static/media/figma.c067749b.svg";